import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { getInventorySources } from './api';
import { emptyArray } from 'ui-components/default-props/empty';

const useInventoryWarehouses = () => {
  const [loading, setLoading] = useAsyncSafeState(false);
  const [errors, setErrors] = useAsyncSafeState([]);
  const [data, setData] = useAsyncSafeState(emptyArray);

  const fetchInventoryWarehouses = useCallback(
    async (inventorySourceGuid = undefined) => {
      setLoading(true);
      setErrors([]);
      try {
        const results = await getInventorySources(false);

        setData(
          results?.reduce((acc, inventorySource) => {
            inventorySource?.warehouses?.forEach((warehouse) => {
              if (!warehouse || !warehouse.inventorySourceExternalId) {
                return;
              }

              if (inventorySourceGuid && warehouse.inventorySourceGuid !== inventorySourceGuid) {
                return;
              }

              acc.push({
                key: warehouse.inventorySourceExternalId,
                text: warehouse.name,
              });
            });

            return acc;
          }, []) ?? emptyArray,
        );
      } catch (error) {
        setErrors([error]);
      } finally {
        setLoading(false);
      }
    },
    [setData, setErrors, setLoading],
  );

  return {
    fetchInventoryWarehouses,
    data,
    loading,
    errors,
  };
};

export default useInventoryWarehouses;
